var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('h3',{staticClass:"mb-4"},[_vm._v(_vm._s(_vm.fieldData.label))]),_c('codemirror',{attrs:{"options":{
    tabSize: 2,
    mode: 'text/' + _vm.fieldData.language,
    theme: 'base16-dark',
    lineNumbers: true,
    line: true
  }},model:{value:(_vm.proxyValue),callback:function ($$v) {_vm.proxyValue=$$v},expression:"proxyValue"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }